import React, {useState} from "react";
import {Box, Checkbox, Grid, Typography} from "@mui/material";
import {Colors} from "../../Constants/Colors";
import {ComponentConfig} from "../../Config/ComponentConfig.js";
import PrimaryButton from "../Common/PrimaryButton.tsx";
import {SecondaryService} from "../../Types/index.ts";
import Api from "../../Interceptor/Api/index.ts";
import {sanitizeKey} from "../../Helper/SanitizeKey.ts";

// Define the props interface
interface Props {
    title: string;
    appointmentId?: number;
    recommendedServices: SecondaryService[];
    buttonTitle: string;
    onTap: (selectedOptions: string[]) => void;
}

const RecommendedServices: React.FC<Props> = ({
                                                  title,
                                                  appointmentId,
                                                  recommendedServices,
                                                  buttonTitle,
                                                  onTap,
                                              }) => {
    const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

    // Handle checkbox change
    const handleChange = (option: string) => {
        setSelectedOptions((prev) =>
            prev.includes(option)
                ? prev.filter((item) => item !== option)
                : [...prev, option]
        );
    };

    const optService = async () => {
        const data = {
            id: appointmentId,
            appointment: {},
        };
        const services = selectedOptions.reduce((acc, option) => {
            acc[`${option}_opted`] = true;
            return acc;
        }, {});

        data.appointment = services;
        try {
            await Api.appointment.optAppointmentSecondaryServices(data);
            await Api.appointment.getAppointmentDetails(appointmentId);
        } catch (error) {
            console.log("Error opting services:", error);
        }
    };

    // Handle button click
    const handleSubmit = () => {
        onTap(selectedOptions);
    };

    return (
        <Box
            sx={{
                p: 3,
                borderRadius: ComponentConfig.CardBorderRadius,
                width: "100%",
                mx: "auto",
                bgcolor: Colors.appointmentCardBgColor,
            }}
        >
            {/* Title */}
            <Typography variant="subtitleBold" className="subtitle-bold">
                {title}
            </Typography>

            {/* Checkbox Options */}
            <Grid container marginTop="4px" spacing={2}>
                {recommendedServices
                    ?.filter((option: SecondaryService) => option?.doctor_prescribed)
                    ?.map((option: SecondaryService) => (
                        <Grid
                            item
                            xs={12}
                            key={option?.service_type}
                            sx={{
                                padding: 0,
                                margin: 0,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                }}
                            >
                                <Checkbox
                                    checked={
                                        selectedOptions.includes(option?.service_type) ||
                                        option?.customer_opted_in
                                    }
                                    disabled={option?.customer_opted_in}
                                    onChange={() => handleChange(option?.service_type)}
                                    sx={{
                                        padding: 0,
                                        color: Colors.primaryTextColor,
                                        opacity: option?.customer_opted_in ? 0.5 : 1,
                                        borderRadius: ComponentConfig.CardBorderRadius,
                                        "&.Mui-checked": {
                                            color: Colors.greenBorderColor,
                                        },
                                    }}
                                />
                                <Typography
                                    className="body-regular"
                                    sx={{
                                        color: Colors.primaryTextColor,
                                        fontWeight: ComponentConfig.fonts.bodyRegular.fontWeight,
                                        fontSize: ComponentConfig.fonts.bodyRegular.fontSize,
                                    }}
                                >
                                    {sanitizeKey(option?.service_type)}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
            </Grid>

            {/* Button */}
            {/*<PrimaryButton*/}
            {/*    variant="contained"*/}
            {/*    text={buttonTitle}*/}
            {/*    textColor={Colors.white}*/}
            {/*    textClassName="body-regular"*/}
            {/*    onTap={optService}*/}
            {/*    fullWidth={false}*/}
            {/*    sx={{*/}
            {/*        marginTop: 2,*/}
            {/*        background: ComponentConfig.primaryButtonGradient,*/}
            {/*    }}*/}
            {/*/>*/}

            {/* Text & Button */}
            {(() => {
                const hasAnyOpted = recommendedServices.some(
                    (service: SecondaryService) => service.doctor_prescribed && service.customer_opted_in
                );

                const hasAnyNotOpted = recommendedServices.some(
                    (service: SecondaryService) => service.doctor_prescribed && !service.customer_opted_in
                );

                return (
                    <>
                        {hasAnyOpted && (
                            <Typography
                                className="body-regular"
                                sx={{
                                    color: Colors.primaryTextColor,
                                    fontWeight: ComponentConfig.fonts.bodyRegular.fontWeight,
                                    fontSize: ComponentConfig.fonts.bodyRegular.fontSize,
                                    marginTop: 2,
                                }}
                            >
                                Thanks! We will reach out to you shortly.
                            </Typography>
                        )}

                        {hasAnyNotOpted && (
                            <PrimaryButton
                                variant="contained"
                                text={buttonTitle}
                                textColor={Colors.white}
                                textClassName="body-regular"
                                onTap={optService}
                                fullWidth={false}
                                sx={{
                                    marginTop: 2,
                                    background: ComponentConfig.primaryButtonGradient,
                                }}
                            />
                        )}
                    </>
                );
            })()}

        </Box>
    );
};

export default RecommendedServices;
